import React from "react";
import { useNavigate } from "react-router-dom";
import ServiceCard from "./components/ServiceCard";
import TaglineBanner from "./components/TaglineBanner";
import livestock from "../../assets/img/livestock.png";
import crops from "../../assets/img/crops.png";
import fishiries from "../../assets/img/fishiries.png";
import dar_logo from "../../assets/img/dar_logo.png";
import landbank_logo from "../../assets/img/landbank_logo.png";
import gcash_logo from "../../assets/img/gcash_logo.png";
import rural_transport from "../../assets/img/rural_transport.png";
import kadiwa_sell from "../../assets/img/kadiwa_sell.png";

const services = [
  {
    id: 1,
    title: "LIVESTOCK",
    description:
      "Manage livestock records, health, breeding and production.",
    image: livestock,
    url: '/panel/services',
  },
  {
    id: 2,
    title: "CROPS & VEGETABLES",
    description:
      "Track crops, inputs, planting, harvest and farm management.",
    image: crops,
    url: '#',
  },
  {
    id: 3,
    title: "FISHERIES",
    description:
      "Fishery registration, monitoring, catch tracking and resources.",
    image: fishiries,
    url: '#',
  },
  {
    id: 4,
    title: "DAR",
    description:
      "Land distribution, beneficiaries, resources and support services.",
    image: dar_logo,
    url: '#',
  },
  {
    id: 5,
    title: "LANDBANK",
    description:
      "Loans, accounts, payments and financial services for farmers.",
    image: landbank_logo,
    url: '#',
  },
  {
    id: 6,
    title: "GCASH",
    description:
      "Digital payments, e-wallet, bills and cash-in / cash-out services.",
    image: gcash_logo,
    url: '#',
  },
  {
    id: 7,
    title: "RURAL TRANSPORT",
    description:
      "Transport services for people, livestock and crops. Schedules, bookings and logistics support.",
    image: rural_transport,
    url: '#',
  },
  {
    id: 8,
    title: "KADIWA SELL",
    description:
      "Sell your produce and products. Market access, KADIWA goods, prices and availability.",
    image: kadiwa_sell,
    url: '#',
  },
];

const ServicesPage = () => {
  const navigate = useNavigate();

  const handleServiceClick = (service) => {
    navigate(`${service.url}`);
  };

  return (
    <div className="min-h-screen bg-[#f7faf7]">
        <section className="mx-auto">
          <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
            {services.map((service) => (
              <ServiceCard
                key={service.id}
                service={service}
                onClick={() => handleServiceClick(service)}
              />
            ))}
          </div>
        </section>
        <TaglineBanner />
    </div>
  );
};

export default ServicesPage;